import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const tagsInputVariants = tv({
  base: `
    flex rtl:flex-row-reverse flex-wrap items-center rounded-md border transition-[background-color,border-color,color,box-shadow]
    aria-[disabled=true]:bg-(--gray-bg-2-alpha) aria-[readonly=true]:bg-(--gray-bg-2-alpha)
  `,
  slots: {
    input: `
      grow border-none outline-none text-(--gray-text-2) rtl:text-right read-only:cursor-auto
      disabled:cursor-not-allowed placeholder:text-(--gray-primary-1-alpha)
    `,
    cursor: "",
    tag: "",
    text: ""
  },
  variants: {
    size: {
      sm: { base: "px-1 min-h-6 gap-0.5" },
      default: { base: "px-2 py-1 min-h-9 gap-1" },
      lg: { base: "px-2 py-1 min-h-10 gap-1" }
    },
    variant: {
      default: {
        base: `
          bg-(--white) border-(--gray-tag-3-alpha) aria-invalid:border-(--red-6-alpha) data-focused:ring-[1px]
                       data-focused:border-(--border-3-alpha)             data-focused:ring-(--border-1-alpha)
          aria-invalid:data-focused:border-(--red-6-alpha)    aria-invalid:data-focused:ring-(--red-3-alpha)
        `
      },
      filled: {
        base: `
          border-transparent bg-(--tag-1-alpha) aria-invalid:bg-(--red-3-alpha)
                       hover:bg-(--tag-2-alpha) aria-invalid:hover:bg-(--red-4-alpha)
          data-focused:bg-(--tag-3-alpha) aria-invalid:data-focused:bg-(--red-5-alpha)
        `
      },
      ghost: {
        base: `
          border-transparent hover:bg-(--tag-1-alpha) aria-invalid:hover:bg-(--red-3-alpha)
          data-focused:bg-(--tag-2-alpha) aria-invalid:data-focused:bg-(--red-4-alpha)
        `
      }
    },
    // 设置input的placeholder，当没有值时显示“...”
    placeholder: {
      false: {},
      true: { input: "text-ellipsis" }
    },
    disabled: {
      false: {},
      true: { cursor: "cursor-not-allowed" }
    },
    ariaInvalid: {
      false: {},
      true: {
        tag: "bg-(--red-3-alpha) aria-invalid:text-(--red-11)",
        text: "text-(--red-12)"
      }
    }
  },
  defaultVariants: {
    size: "default",
    variant: "default",
    placeholder: !1,
    disabled: !1,
    ariaInvalid: !1
  }
});
export {
  tagsInputVariants
};
//# sourceMappingURL=index.js.map
